import React from 'react';
import { imgUrls } from 'constants/imgUrls';
import { BiSolidLogOutCircle } from 'react-icons/bi';
import { appRoutesUrls } from 'constants/appRoutesUrls';
import { BsBagDashFill, BsFillCartPlusFill, BsFillPeopleFill, BsHouseDoorFill } from 'react-icons/bs';
import { NavLink } from 'react-router-dom';

const AdminSidebar = ({ logout, toggleSidebar }) => {

    return (
        <>
            <div className="sidebar" data-background-color="dark">
                <div className="sidebar-logo">
                    <div className="logo-header" data-background-color="dark">
                        <div className="logo">
                            <img
                                src={imgUrls.logo}
                                className="navbar-brand"
                                width="190"
                                height="50"
                                alt="Krishna Prints Solution"
                                style={{ background: 'white' }}
                            />
                        </div>
                        <div className="nav-toggle" onClick={toggleSidebar}>
                            <button className="btn btn-toggle toggle-sidebar">
                                <i className="gg-menu-right"></i>
                            </button>
                            <button className="btn btn-toggle sidenav-toggler">
                                <i className="gg-menu-left"></i>
                            </button>
                        </div>
                    </div>
                </div>
                <div className="sidebar-wrapper scrollbar scrollbar-inner">
                    <div className="sidebar-content">
                        <ul className="nav nav-secondary">
                            <li className="nav-section">
                                <span className="sidebar-mini-icon">
                                    <i className="fa fa-ellipsis-h"></i>
                                </span>

                            </li>
                            <li className="nav-item">
                                <NavLink to={appRoutesUrls.dashboard()}>
                                    <BsHouseDoorFill size={20} />
                                    <p className='ms-3'>Dashboard</p>
                                </NavLink>
                            </li>
                            <li className="nav-item">
                                <a data-bs-toggle="collapse" href="#users">
                                    <BsFillPeopleFill size={20} />
                                    <p className='ms-3'>Users</p>
                                    <span className="caret"></span>
                                </a>
                                <div className="collapse" id="users">
                                    <ul className="nav nav-collapse">
                                        <li>
                                            <NavLink to={appRoutesUrls.users()}>
                                                <span className="sub-item">Users</span>
                                            </NavLink>
                                        </li>
                                    </ul>
                                </div>
                            </li>
                            <li className="nav-item">
                                <a data-bs-toggle="collapse" href="#sales">
                                    <BsFillCartPlusFill size={20} />
                                    <p className='ms-3'>Sales</p>
                                    <span className="caret"></span>
                                </a>
                                <div className="collapse" id="sales">
                                    <ul className="nav nav-collapse">
                                        <li>
                                            <NavLink to={appRoutesUrls.customers()}>
                                                <span className="sub-item"> Customers</span>
                                            </NavLink>
                                        </li>
                                        <li>
                                            <NavLink to={appRoutesUrls.invoices()}>
                                                <span className="sub-item">Invoices</span>
                                            </NavLink>
                                        </li>
                                    </ul>
                                </div>
                            </li>
                            <li className="nav-item">
                                <a data-bs-toggle="collapse" href="#purchases">
                                    <BsBagDashFill size={20} />
                                    <p className='ms-3'>Purchases</p>
                                    <span className="caret"></span>
                                </a>
                                <div className="collapse" id="purchases">
                                    <ul className="nav nav-collapse">
                                        <li>
                                            <NavLink>
                                                <span className="sub-item">Suppliers</span>
                                            </NavLink>
                                        </li>
                                    </ul>
                                </div>
                            </li>
                            <li className="nav-item">
                                <NavLink to={appRoutesUrls.logout()} onClick={logout}>
                                    <BiSolidLogOutCircle size={22} />
                                    <p className='ms-3'>Logout</p>
                                </NavLink>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </>
    )
}

export default AdminSidebar;